import { StyleSheet, Font } from '@react-pdf/renderer';

Font.register({
    family: "Calibri",
    fonts: [
        { src: require("../../Font/calibri.ttf") },
        {
            src: require("../../Font/calibrib.ttf"),
            fontWeight: "bold"
        },
        {
            src: require("../../Font/calibrii.ttf"),
            fontStyle: "italic"
        },
        {
            src: require("../../Font/calibriib.ttf"),
            fontStyle: "italic",
            fontWeight: "bold"
        },
    ]
});

export const stylesForPdf = StyleSheet.create({
    body: {
        paddingTop: 37,
        paddingBottom: 60,
        paddingLeft: 72,
        paddingRight: 72,
        fontSize: 11,
        fontFamily: "Calibri",
        position: "relative",
    },

    watermark: {
        fontSize: 56,
        opacity: 0.2,
        fontWeight: "bold",
        transform : "rotate(-40deg)",
        top: 320,
        left: 40,
        position: "absolute",
    },

    draft: {
        color: '#EB0000',
    },

    mainTitle: {
        marginTop: 19,
        marginBottom: 31.5,
        fontSize: 18,
        fontWeight: "bold",
        textAlign: "center",
        fontFamily: "Calibri"
    },

    mainTitleInVER2: {
        marginTop: 12,
        marginBottom: 31.5,
        fontSize: 18,
        fontWeight: "bold",
        textAlign: "center",
        fontFamily: "Calibri"
    },

    sectionTitle: {
        marginBottom: 10,
        fontSize: 16,
        fontWeight: "bold",
        fontFamily: "Calibri"
    },

    sectionQuestionBlocksTitle: {
        marginTop: 21,
        fontSize: 14,
        fontWeight: "bold",
        fontFamily: "Calibri"
    },

    sectionBlockTitleINF: {
        marginTop: 18,
        marginBottom: 5,
        fontSize: 14,
        fontWeight: "bold",
        fontFamily: "Calibri"
    },

    section: {
        marginTop: 8,
        marginBottom: 20,
        fontSize: 13,
        fontWeight: "bold",
        fontFamily: "Calibri"
    },

    sectionLowerMargin: {
        marginTop: 8,
        marginBottom: 4,
        fontSize: 13,
        fontWeight: "bold",
        fontFamily: "Calibri"
    },

    sectionTitle2: {
        marginBottom: 10,
        fontSize: 13,
        fontWeight: "bold",
        fontFamily: "Calibri",
        height: 16,
        width: "200%",
    },

    sectionTitle2View: {
        maxWidth: '100%',
        overflow: 'hidden'
    },

    tableTop: {
        marginBottom: 3,
        display: "table",
        width: "65%",
        borderCollapse: "collapse"
    },

    tableTopFullWidth: {
        marginBottom: 3,
        display: "table",
        width: "100%",
        borderCollapse: "collapse"
    },

    tableBottom: {
        marginTop: 12,
        display: "table",
        width: "65%",
        borderCollapse: "collapse"
    },

    tableBottomFullWidth: {
        marginTop: 12,
        display: "table",
        width: "100%",
        borderCollapse: "collapse"
    },

    table: {
        marginBottom: 12,
        display: "table",
        width: "65%",
        borderCollapse: "collapse"
    },

    tableFullWidth: {
        marginBottom: 12,
        display: "table",
        width: "100%",
        borderCollapse: "collapse"
    },

    tableRow: {
        marginBottom: 7,
        flexDirection: "row",
        fontSize: 11,
        fontFamily: "Calibri",
        width: '100%',
    },

    tableCol: {
        width: '65%',
        minWidth: '65%',
        fontWeight: "bold",
    },

    tableTitleCol40: {
        width: '40%',
        minWidth: '40%',
        maxWidth: '40%',
        fontWeight: "bold",
    },

    tableTitleCol50: {
        width: '50%',
        minWidth: '50%',
        maxWidth: '50%',
        fontWeight: "bold",
    },

    tableCol50: {
        width: '50%',
        minWidth: '50%',
        maxWidth: '50%',
    },

    tableCol60: {
        width: '60%',
        minWidth: '60%',
        maxWidth: '60%',
    },

    orderTable: {
        width: '100%',
    },

    orderTableHeaderRow: {
        display: 'flex',
        flexDirection: "row",
        borderLeft: 0.75,
        borderBottom: 0.75,
        borderTop: 0.75,
        fontFamily: "Calibri",
        fontWeight: "bold",
        fontSize: 10,
        textAlign: 'center',
        width: '100%',
        backgroundColor: '#F2F2F2'
    },

    orderTableRow: {
        display: 'flex',
        flexDirection: "row",
        textAlign: 'left',
        borderTop: 0.75,
        borderBottom: 0.75,
        borderLeft: 0.75,
        fontFamily: "Calibri",
        fontSize: 10,
        width: '100%',
    },

    orderTableCell: {
        width: '35%',
        borderRight: 0.75,
        paddingLeft: 1,
        paddingRight: 1
    },

    questionContainer: {
        marginBottom: 0,
    },

    questionBlock: {
        marginTop: 12,
        marginBottom: 12,
        fontSize: 13,
        fontWeight: "bold",
        textDecoration: 'underline'
    },

    question: {
        marginBottom: 7,
        fontSize: 11,
        fontWeight: "bold"
    },

    findingKind: {
        marginBottom: 7,
        fontSize: 11,
    },

    commentContent: {
        marginBottom: 7,
        fontSize: 11,
    },

    findingKindBold: {
        marginBottom: 7,
        fontSize: 11,
        fontWeight: "bold",
    },

    comment: {
        marginTop: 1,
        marginBottom: 2,
        fontWeight: "bold",
        fontSize: 11,
    },

    attachments: {
        marginBottom: 2,
        fontStyle: "italic",
        fontWeight: "bold",
        fontSize: 11,
    },

    noAttachments: {
        marginBottom: 2,
        fontSize: 11,
    },

    attachment: {
        marginBottom: 2,
        fontStyle: "italic",
        fontSize: 11,
    },

    attachmentsContainer: {
        marginBottom: 5
    },

    notApply: {
        marginTop: -8,
        fontSize: 11,
    },

    abbr: {
        marginBottom: 2,
        fontSize: 11,
    },

    arrangements: {
        marginBottom: 2,
        fontSize: 11,
    },

    tableBottomNoMargin: {
        display: "table",
        width: "65%",
        marginTop: 0,
        borderCollapse: "collapse"
    },

    tableBottomNoMarginFullWidth: {
        display: "table",
        width: "100%",
        marginTop: 0,
        borderCollapse: "collapse"
    },

    note: {
        marginBottom: 15,
        fontSize: 11,
        fontFamily: "Calibri",
        textAlign: "left",
        width: "auto",
    },

    textLine: {
        marginTop: 1,
        marginBottom: 2,
        fontSize: 11,
    },

    ftabTable: {
        width: '100%',
    },

    ftabHeaderRow: {
        flexDirection: "row",
        borderLeft: 0.75,
        borderBottom: 0.75,
        borderTop: 0.75,
        width: '100%',
        fontFamily: "Calibri",
        fontWeight: "bold",
        fontSize: 10,
        textAlign: 'center',
        backgroundColor: '#F2F2F2'
    },

    ftabRow: {
        flexDirection: "row",
        borderLeft: 0.75,
        borderBottom: 0.75,
        borderTop: 0.75,
        width: '100%',
        fontFamily: "Calibri",
        fontSize: 10
    },

    ftabCell: {
        borderRight: 1,
        paddingLeft: 1,
        paddingRight: 1
    },

    finding: {
        marginTop: 8,
        marginBottom: 0,
        fontSize: 13,
        fontWeight: "bold",
        fontFamily: "Calibri",
        textDecoration: "underline"
    },

    findingName: {
        marginBottom: 12,
        fontSize: 11,
        fontFamily: "Calibri",
    },

    findingRow: {
        marginBottom: 12,
        fontSize: 11,
        fontFamily: "Calibri",
    },

    noFindings: {
        marginBottom: 2,
        fontSize: 11
    },

    pageHeader: {
        fontSize: 8,
        textAlign: 'center',
        color: 'grey',
        fontFamily: "Calibri",
        marginBottom: 20
    },

    pageNumber: {
        position: 'absolute',
        fontSize: 8,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
        fontFamily: "Calibri"
    },

    verticalCenter: {
        paddingTop: 3,
        marginVertical: 'auto'
    }
});

